import type { FaireProductEntity } from "../../entity_types/product";

export const p_ua4ckf9che: FaireProductEntity = {
  token: "p_ua4ckf9che",
  type: "product",
  name: "Value Velvet Wired Edge, Scarlet, 4 In, 10 Yards",
  brandName: "Upscaling Demo Brand",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/6f45b0d0225217ea3f26fc89284bbdae86ab9bba15e2cb56ec007f7e50d02bb4.jpeg",
  afterImageUrl:
    "https://cdn.prerelease.faire.dev/fastly/a435b912cc369751f3d408deb5939e90a92f0709a6ccd839a42722fedcd32a61.jpeg",
  priceDollars: 24,
  description: "Image upscaling comparison product.",
  categoryTokens: ["cat_proto_image-upscaling"],
  tags: ["upscaling"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
